import * as React from 'react';

const SVGIllustrationGeneralError: React.SFC<SvgProps> = props => (
    <svg width={600} height={353} {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                stroke="#9BC3D3"
                d="M16.093 320.077h146.232V173.845H16.093z"
            />
            <path
                stroke="#9BC3D3"
                d="M16.093 190.077h146.232v-16.232H16.093zm0 0l146.232 130m-146.232 0l146.232-130"
            />
            <path
                stroke="#9BC3D3"
                d="M589.323 246.5h-264c-5.522 0-10-4.477-10-10v-200h284v200c0 5.523-4.477 10-10 10z"
            />
            <path
                stroke="#9BC3D3"
                d="M599.323 36.5h-284v-26c0-5.523 4.478-10 10-10h264c5.523 0 10 4.477 10 10v26z"
            />
            <path
                fill="#9BC3D3"
                d="M344.324 18.5a9.001 9.001 0 11-18.002-.001 9.001 9.001 0 0118.002.001"
            />
            <path
                fill="#FC3"
                d="M372.324 18.5a9.001 9.001 0 11-18.002-.001 9.001 9.001 0 0118.002.001"
            />
            <path
                fill="#C3DEE7"
                d="M400.324 18.5a9.001 9.001 0 11-18.002-.001 9.001 9.001 0 0118.002.001"
            />
            <path fill="#DEEDF2" d="M197.21 352.717h134.049v-8.697H197.21z" />
            <path
                fill="#DEEDF2"
                d="M267.126 352.717h-90.791c-4.237 0-6.553-4.94-3.844-8.197l73.544-88.429h101.453l-80.362 96.626z"
            />
            <path
                fill="#9BC3D3"
                d="M304.724 307.485l-73.737-33.335 101.51-.046z"
            />
            <path
                fill="#DEEDF2"
                d="M436.059 274.926H128.387c-5.523 0-10-4.477-10-10V79.177c0-5.523 4.477-10 10-10h307.672c5.523 0 10 4.477 10 10v185.749c0 5.523-4.477 10-10 10m77.594 77.501h-47.967c-4.66 0-8.44-5.466-8.44-10.128v-65.836h64.847v65.836c0 4.662-3.778 10.129-8.44 10.129"
            />
            <path
                fill="#DEEDF2"
                d="M521.816 340.611v-5.026c10.53 0 16.566-8.73 16.566-18.517 0-9.79-6.035-18.517-16.566-18.517v-5.026c14.055 0 26.334 10.56 26.334 23.543 0 12.982-12.28 23.543-26.334 23.543"
            />
            <path
                fill="#F2F8FA"
                d="M550.092 192.057c-49.8 57.396-50.607 84.406-50.607 84.406h-18.006s3.79-41.165 55.108-106.35c62.46-79.342 15.015-148.573 9.285-159.527 0 0 103.216 67.374 4.22 181.471"
            />
            <path
                fill="#C3DEE7"
                d="M459.072 276.463h-1.826v65.836c0 4.662 3.779 10.129 8.44 10.129h47.968c1.25 0 2.433-.403 3.5-1.07l-58.082-74.895z"
            />
            <path fill="#1BB3BE" d="M457.246 287.435h64.848v-6.752h-64.848z" />
            <path
                fill="#FC3"
                d="M98.936 35.915l-9.472 9.472-9.472-9.472 9.472-9.472z"
            />
            <path
                fill="#F2F8FA"
                d="M446.059 252.246V79.177c0-5.523-4.477-10-10-10H128.387c-5.523 0-10 4.477-10 10v173.069h327.672z"
            />
            <path
                fill="#9BC3D3"
                d="M17.72 113.727h145.814v-8.464H17.72zm-17.72 0h7.814v-8.464H0z"
            />
            <path
                fill="#DEEDF2"
                d="M181.169 134.059h204.489v-10.26H181.169zm-.001 40.681H291.98v-10.26H181.168z"
            />
        </g>
    </svg>
);

export default SVGIllustrationGeneralError;
